module.exports = __webpack_public_path__ + "img/mrsmith-desktop.e5a61cff.webp";